import { getClientId } from "@smartsheet/lodestar-utils";
import { useFlyout } from "../../flyout";
export var useSelectFlyout = function useSelectFlyout(_ref) {
  var closeMenu = _ref.closeMenu,
    clientId = _ref.clientId,
    isOpen = _ref.isOpen,
    menuId = _ref.menuId,
    menuPlacement = _ref.menuPlacement,
    menuPosition = _ref.menuPosition,
    portalProps = _ref.portalProps,
    targetRef = _ref.targetRef,
    updateKey = _ref.updateKey;
  var _useFlyout = useFlyout({
      id: menuId,
      clientId: getClientId(clientId, "-menu"),
      // Always true, we never hide the menu root itself, just its children.
      isOpen: true,
      // Since the menu is always open, we don't want it to be in the stacking context when "closed".
      ignoreStackOrder: !isOpen,
      onCloseRequested: closeMenu,
      targetRef: targetRef,
      placement: menuPlacement ? menuPlacement : "bottom-start",
      offset: {
        distance: 4
      },
      popperProps: {
        strategy: menuPosition
      },
      portalProps: portalProps,
      // Update positioning whenever the open state changes.
      // We need the open state because if it's closed, and something else moves the combobox, the
      // menu needs to recalc or it will still be pointing at the position of its initial render.
      updateKey: updateKey
      // closeOnEscape: false,
    }),
    _useFlyout$targetProp = _useFlyout.targetProps,
    targetRefFromFlyout = _useFlyout$targetProp.ref,
    ariaOwns = _useFlyout$targetProp["aria-owns"],
    flyoutProps = _useFlyout.flyoutProps;
  return {
    // The props to be spread onto the SelectMenu's Flyout.
    flyoutProps: flyoutProps,
    // The target, which is the thing the Flyout should point at, not interact with.
    // This should be the root element of the select component.
    targetRef: targetRefFromFlyout,
    ariaOwns: ariaOwns,
    ariaControls: ariaOwns
  };
};
//# sourceMappingURL=useSelectFlyout.js.map